import { Box } from '@material-ui/core';
import Slider from '@material-ui/core/Slider';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { useEffect, useState } from 'react';
import { useATCPlan } from "../store/ATCPlanState";
import { elapsedTimeForWeatherState, elapsedTimeState } from "../store/ElapsedTimeState";
import { useSetRecoilState } from "recoil";
import { isReverseRoute, parseUTCDate } from "../utils/FPEUtils";

function TimeController() {
  const [sliderValue, setSliderValue] = useState([]);
  const [marks, setMarks] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [value, setValue] = useState(0);
  const [invert, setInvert] =  useState(false);
  const {atcPlan} = useATCPlan();
  const setElapsedTime = useSetRecoilState(elapsedTimeState);
  const setElapsedTimeForWeather = useSetRecoilState(elapsedTimeForWeatherState);

  useEffect(() => {
    const isNewPlan = atcPlan.original.text === atcPlan.edit.text;
    let elapsedSec = 0;
    let elapsedIndex = value;
    if (!isNewPlan) {
      if (invert) {
        elapsedIndex = sliderValue.length - value - 1;
      }
      if(!sliderValue[elapsedIndex]) {
        elapsedSec = sliderValue[sliderValue.length - 1].elapsedSec;
      } else {
        elapsedSec = sliderValue[elapsedIndex].elapsedSec;
      }
    }
    const slider = createSliderValue(atcPlan.edit.json, setElapsedTime, setElapsedTimeForWeather, elapsedSec);
    let _invert;
    if(0 < slider.length) {
      setDisabled(false);
      _invert = isReverseRoute(atcPlan.edit.json.dep.lon, atcPlan.edit.json.arr.lon);
      setInvert(_invert);
      let index;
      if (isNewPlan) {
        if (!_invert) {
          index = 0;
        } else {
          index = slider.length - 1;
        }
      } else {
        if (!_invert) {
          index = elapsedIndex;
        } else {
          index = slider.length - elapsedIndex - 1;
        }
      }
      setValue(index);
    } else {
      setInvert(false);
      setDisabled(true);
    }

    setMarks(createSliderLabel(slider, atcPlan.edit.json, _invert));
    setSliderValue(slider);
  },
  // eslint-disable-next-line
  [atcPlan, setElapsedTime, setElapsedTimeForWeather]);

  const classes = boxStyle();

  const handleOnChangeCommitted = (e, value) => {
    const idx = invert ? (sliderValue.length -1) - value : value;
    setElapsedTimeForWeather(sliderValue[idx].elapsedSec);
  }
  const handleOnChange = (e, value) => {
    setValue(value);
    const idx = invert ? (sliderValue.length -1) - value : value;
    setElapsedTime(sliderValue[idx].elapsedSec);
  }

  const valueLabelFormat = (value) => {
    const idx = invert ? (sliderValue.length -1) - value : value;
    return sliderValue[idx]?.elapsedTime ?? "";
  }

  const track = invert ? 'inverted' : 'normal';

  return (
    <div id="time-controller" className="time-controller">
        <Box className={classes.innerBox} >
          <TimeSlider
            disabled={disabled}
            value={value}
            valueLabelDisplay="auto"
            defaultValue={0}
            max={sliderValue.length - 1}
            min={0}
            step={1}
            track={track}
            onChange={(e, value) => handleOnChange(e, value)}
            onChangeCommitted={(e, value) => handleOnChangeCommitted(e, value)}
            valueLabelFormat={valueLabelFormat}
            ValueLabelComponent={ValueLabelComponent}
            onMouseOver={(e, value) => handleMoueOver(e, value)}
            marks={marks.length === 0 ? false : marks}
          />
        </Box>
    </div>
  );
}

const createSliderValue = (json, setElapsedTime, setElapsedTimeForWeather, elapsedSec) => {
  const sliderValue = [];
  if(Object.keys(json).length === 0) {
    return sliderValue;
  }
  let cumulativeTime = calcCumulativeTime(json.route);
  cumulativeTime += json.arr.time;

  const cumulativeMin = Math.ceil(cumulativeTime / 60);
  for(let min = 0; min <= cumulativeMin; min++) {
    sliderValue.push({
      elapsedTime: minToHHMM(min),
      elapsedSec: min * 60
    });
  }
  setElapsedTime(elapsedSec);
  setElapsedTimeForWeather(elapsedSec);
  return sliderValue;
}

const calcCumulativeTime = (route, cumulativeTime = 0) => {
  for(const record of route) {
    if(record.hasOwnProperty('airway')) {
      cumulativeTime += calcCumulativeTime(record.airway);
    } else {
      cumulativeTime += record.time;
    }
  }
  return cumulativeTime;
}

const minToHHMM = (min) => {
  return `${('0' + Math.floor(min / 60)).slice(-2)}:${('0' + min % 60).slice(-2)}`;
}

const handleMoueOver = (e, value) => {
  // TODO マウスオーバした箇所にツールチップを出す
}

const ValueLabelComponent = (props) => {
  const {atcPlan} = useATCPlan();
  const [etd, setETD] = useState();

  useEffect(() => {
    setETD(getETD(atcPlan.edit.json));
  },[atcPlan.edit.json]);

  const { children, open, value } = props;
  if(value === '') {
    return(<></>);
  }
  const date = new Date(etd.getTime());
  const time = value.split(':');
  date.setUTCHours(date.getUTCHours() + parseInt(time[0]), date.getUTCMinutes() + parseInt(time[1]));
  const h = ('00' + date.getUTCHours()).slice(-2);
  const m = ('00' + date.getUTCMinutes()).slice(-2);
  return (
    <>
      <TimeToolTip open={open} enterTouchDelay={0} placement="top" title={value}>
        {children}
      </TimeToolTip>
      <UnderTimeToolTip open={true} enterTouchDelay={0} placement="bottom" title={`${h}:${m}Z`}>
        {children}
      </UnderTimeToolTip>
    </>
  );
}
ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
};

const boxStyle = makeStyles({
  innerBox: {
    width: "100%"
  }
})

const TimeToolTip = withStyles({
  tooltip: {
    backgroundColor: '#52af77',
    fontSize: 13
  },
  tooltipPlacementTop: {
    marginBottom: 5
  }
})(Tooltip)

const UnderTimeToolTip = withStyles({
  popper: {
    height: 12
  },
  tooltip: {
    backgroundColor: '#52af77',
    fontSize: 13
  },
  tooltipPlacementBottom: {
    marginTop: 0,
    height: 12,
    lineHeight: 1
  }
})(Tooltip)

const TimeSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
    marginBottom: 14
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
  trackInverted: {
    '& .MuiSlider-track' : {
      backgroundColor: 'rgb(88, 130, 125)'
    }
  },
  markLabel: {
    color: '#69d5b2'
  },
  mark: {
    height: 6,
    width: 1,
    top: 20,
    backgroundColor: '#69d5b2'
  }
})(Slider);

const createSliderLabel = (sliderValue, json, invert) => {
  const marks = [];

  if(sliderValue.length === 0) {
    return marks;
  }

  const etd = getETD(json);
  let hour = 1;
  if(invert) {
    marks.push({value: sliderValue.length - 1, label: `${('00' + etd.getUTCHours()).slice(-2)}:${('00' + etd.getUTCMinutes()).slice(-2)}Z`});
    for(let i = sliderValue.length - 1 - 60; 0 <= i; i-=60) {
      marks.push({value: i, label: `+${('00' + hour++).slice(-2)}h`});
    }
  } else {
    marks.push({value: 0, label: `${('00' + etd.getUTCHours()).slice(-2)}:${('00' + etd.getUTCMinutes()).slice(-2)}Z`});
    for(let i = 60; i <= sliderValue.length; i+=60) {
      marks.push({value: i, label: `+${('00' + hour++).slice(-2)}h`});
    }
  }
  return marks;
}

const getETD = json => {
  const dep = json.dep;
  if(!dep) return;
  const dof = json.dof;
  let etd;
  if(dof) {
    etd = parseUTCDate(`${dof} ${dep.etd}00`);
  } else {
    etd = new Date();
    const depTime = parseInt(dep.etd.substr(0, 2));
    const depMin = parseInt(dep.etd.substr(2));
    if(depTime < etd.getUTCHours() || (depTime === etd.getUTCHours() && depMin < etd.getUTCMinutes())) {
      etd.setUTCDate(etd.getUTCDate() + 1);
    }
    etd.setUTCHours(depTime, depMin, 0);
  }
  return etd;
}

export default TimeController;